import { render, staticRenderFns } from "./MainLoader.vue?vue&type=template&id=83ec78a6&scoped=true&"
import script from "./MainLoader.vue?vue&type=script&lang=js&"
export * from "./MainLoader.vue?vue&type=script&lang=js&"
import style0 from "./MainLoader.vue?vue&type=style&index=0&id=83ec78a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ec78a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
